// Copyright (c) 2025 Initiumnet Technologies. All Rights Reserved.

/*
 * "searchRequestStructure.js": This file will have search related all structure definition.
 */

const SearchRequestStructure = {
    startsWith: "",         // The first character to search for
    includeUsers: true,      // Whether to include user-type results
    includeProfiles: true,   // Whether to include profile-type results
    limit: 20,               // (Optional) Limit number of results
  };

const SearchResponseStructure = {
    id: "",                    // Unique identifier (userId or profileId)
    type: "",                  // "user" or "profile"
    name: "",                  // Display name (e.g., "Steve Jobs", "Football Club")
    imageURL: "",             // Profile picture or icon
    description: "",           // Short bio or intro (optional)
    tags: [],                  // Array of interests, skills, or categories
    location: "",              // City or country (optional for display)
    isOnline: false,           // For user type - show online status
  
    // Specific to user
    canMessage: false,
    canAudioCall: false,
    canVideoCall: false,
  
    // Specific to profile
    canVisit: false            // Set true if it's a "profile" and visit is allowed
};